module.exports = __webpack_public_path__ + "img/benefits-teachers-1.b9d431ec.svg";